import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableString } from '../utils/wire-value-utils';

/**
 * An organization's spraying season, built from `/admin/organizations/:id/seasons` JSON
 * (hub `data-models/organization-season.ts`).
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class OrganizationSeason extends Base {
  // Writable via POST / PUT /admin/organizations/:id/seasons
  label?: string | null;
  /** ISO timestamp as sent by the hub. */
  startDate?: string | null;
  /** ISO timestamp as sent by the hub. */
  endDate?: string | null;

  // Read-only
  organizationId?: string | null;
  createdBy?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.label = nullableString(source['label']);
    this.startDate = nullableString(source['startDate']);
    this.endDate = nullableString(source['endDate']);
    this.organizationId = nullableString(source['organizationId']);
    this.createdBy = nullableString(source['createdBy']);
  }
}
